import { CreateSavingsGoal } from '@unistocks/features/savings-goals/create-savings-goal';
import { t } from '@unistocks/shared/localization/index.ts';
import Head from 'expo-router/head';

export default function CreateSavingsGoalScreen() {
  return (
    <>
      <Head>
        <title>{t('::Menu:SavingsGoals:Create')}</title>
      </Head>
      <CreateSavingsGoal />
    </>
  );
}
